import React, {Suspense} from 'react'
import {HashRouter, Switch} from 'react-router-dom';
import Error404 from "./components/ui/Error404";
import ErrorAlert from "./components/containers/ErrorAlert";
import AppSkeleton from "./components/containers/AppSkeleton";

//const Dashboard = lazy(() => import("./components/containers/Dashboard"));

const routes = (
    <HashRouter path={"/"}>
        <Suspense fallback={<div>Loading...</div>}>
            <ErrorAlert/>
            <Switch>
                <AppSkeleton path={"/"}/>
                <Error404 path={"*"}/>
            </Switch>
        </Suspense>
    </HashRouter>
);

export default routes;




